"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listAppBaseDataQueryIssues = listAppBaseDataQueryIssues;
const parser_1 = require("@babel/parser");
const PARSER_OPTIONS = {
    sourceType: 'unambiguous',
    allowAwaitOutsideFunction: true,
    allowImportExportEverywhere: true,
    allowReturnOutsideFunction: true,
    plugins: ['typescript', 'jsx', 'topLevelAwait'],
};
/** Shared syntax diagnosis; App UI and local logic are not an AST allowlist.
 * Server rights and resource admission remain enforced by the existing ports. */
function listAppBaseDataQueryIssues(javascript) {
    try {
        (0, parser_1.parse)(javascript, PARSER_OPTIONS);
        return [];
    }
    catch (error) {
        return [
            {
                code: 'invalid_query_code',
                message: `App Module code could not be parsed safely: ${error.message}`,
            },
        ];
    }
}
